var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "safety_social_tips_page" } }, [
      _c("div", { staticClass: "container" }, [
        _c("span", { staticClass: "page-title" }, [
          _vm._v("Social & safety tips")
        ]),
        _c("p", [
          _vm._v(
            "Here's a list of social and safety tips you need to keep in mind when carpooling for the first time."
          )
        ]),
        _c("h2", [_vm._v("Safety tips")]),
        _c("p", [
          _vm._v(
            "When it comes to sharing journeys, everyone is responsible for their own personal safety. However, we do recommend that you read some simple safety measures outlined below:"
          )
        ]),
        _c("ul", [
          _c("li", [
            _vm._v("Arrange to meet for the first time in a public place.")
          ]),
          _c("li", [
            _vm._v(
              "Don’t exchange home addresses with your travelling companion before you meet them."
            )
          ]),
          _c("li", [
            _vm._v(
              "Show each other ID e.g. passports, student cards or driving licences, so you know you’re travelling with the right person."
            )
          ]),
          _c("li", [
            _vm._v(
              "Trust your instincts; you are under no obligation to go ahead with any carpool arrangement. If you have any doubts about your travelling companion, for any reason, then you don’t have to travel with them."
            )
          ]),
          _c("li", [
            _vm._v(
              "Check that the person you are sharing with has all the legal driving documents, such as driving license, car insurance, NCT and car tax."
            )
          ])
        ]),
        _c("h2", [_vm._v("Social tips")]),
        _c("p", [
          _vm._v(
            "Carpooling may not work out for you and it’s okay to say that to your travelling companion, you don’t have to commit to carpool forever. Agree that each of you can stop at any stage and it’s not a personal thing."
          )
        ]),
        _c("ul", [
          _c("li", [
            _vm._v(
              "Good etiquette is required of all participants including polite and friendly behaviour, and punctuality to agreed appointments."
            )
          ]),
          _c("li", [
            _vm._v(
              "All participants agree to inform their fellow participants as far in advance as possible of any cancellation of a lift, inability to provide or to attend for a lift, or any other interruption to the arrangements agreed between the participants."
            )
          ]),
          _c("li", [
            _vm._v("Set the ground rules of the arrangement at the start.")
          ]),
          _c("li", [
            _vm._v(
              "As a driver, how long you will wait for passengers (5 minutes?)"
            )
          ]),
          _c("li", [
            _vm._v(
              "Text each other 30 minutes beforehand to remind and confirm."
            )
          ]),
          _c("li", [_vm._v("Is eating allowed in the car?")]),
          _c("li", [
            _vm._v(
              "Is the radio the driver’s prerogative, or will you swap stations?"
            )
          ]),
          _c("li", [
            _vm._v("How are fuel costs recorded and what day will you pay?")
          ]),
          _c("li", [
            _vm._v(
              "Agree you’ll talk to each other honestly if there are any issues."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }